import { FormActionButton } from '@workwave-tidal/core/form'
import { useCloseModal } from '@/atoms'

import { useTexts } from '../hooks/useTexts'
import { form } from './formState'

export function Footer() {
  const close = useCloseModal()
  const texts = useTexts()
  const {
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  const saveDisabled = status === 'pristine' || validating || submitting

  return (
    <>
      <FormActionButton
        label={texts.footer.cancel}
        size="medium"
        onClick={close}
        data-testid="modal__button-cancel"
        data-trackid="modal__button-cancel"
      />
      <FormActionButton
        label={texts.footer.delete}
        size="medium"
        variant="contained"
        type="submit"
        disabled={saveDisabled}
        data-testid="modal__button-delete"
        data-trackid="modal__button-delete"
        loading={submitting}
      />
    </>
  )
}
